module.exports = __webpack_public_path__ + "img/A低通5.fa85da58.png";